import { useTheme } from "@emotion/react";
import { Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { Primary, Secondary } from 'ui-components/Buttons';
import { FormikProvider, useFormik } from "formik";
import { styled } from "@mui/styles";
import CustomLabel from "ui-components/CustomLabel";
import { Download } from "@mui/icons-material";
// import sampledata from "assets/sampledata.xlsx";
import { ExportMetricsTemplateFile,ImportMetricsDataFile } from "api/org/performance"; // Ensure correct import path
import { ReactComponent as UploadDocumentsIcon } from "assets/rounds_icons/upload_documents_icon.svg";
import { useSelector } from "react-redux";
import { downloadFile } from "utils/index";
import Cookies from "js-cookie";


const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ImportMetricsDataPopup = ({ handleClose, refetching = () => {} }) => {
  const theme = useTheme();
  const round_id = Cookies.get("round_id")
  // const { id: round_id } = useParams();
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);

  const { mutateAsync: excelMetricTemplateFileAsync, isLoading: isDownloadingExcelMetricTemplateFile } = ExportMetricsTemplateFile();

  const { mutate: importPerformanceDataFromFileAsync, isLoading: isImporting } = ImportMetricsDataFile();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file);
    }
  };

  const handleDownloadSampleFile = () => {

    excelMetricTemplateFileAsync({ startup_id: startup_id }, {
        onSuccess: (succResponse) => {
            // console.log(succResponse?.url,"succResponse")
            downloadFile(succResponse?.url);
        },
        onError: () => {

        }
    })

    // const link = document.createElement("a");
    // link.href = sampledata;
    // link.download = "SampleTemplate.xlsx";
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      message: "",
    },
    validateOnMount: true,
    onSubmit: (values, { setSubmitting }) => {
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("startup_id", startup_id);
        importPerformanceDataFromFileAsync(formData, {
          onSuccess: (response) => {
            // console.log("Import successful:", response.data);
            refetching()
            handleClose(); 
          },
          onError: (error) => {
            console.error("Import failed:", error.response?.data);
          },
        });
      } else {
        console.error("No file selected");
      }
      setSubmitting(false);
    },
  });

  return (
    <Paper
      sx={{
        background: theme.palette.customColors.whiteBG,
        borderRadius: "8px",
      }}
    >
      <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
        <CloseIcon width={40} height={40} onClick={handleClose} />
      </IconButton>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <Grid display={"grid"} container padding={"1.5rem"} gap={"1.5rem"}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  lineHeight: "28px",
                  color: theme.palette.customColors.g300,
                }}
              >
                Import Data
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <CustomLabel>SELECT FILE</CustomLabel>
              <Secondary
                component="label"
                fullWidth
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: `1px solid ${theme.palette.customColors.g75}`,
                  borderRadius: "8px",
                  height: "52px",
                  padding: "10px, 14px",
                  color: "#7A7D83",
                  textTransform: "none",
                }}
              >
                {fileName ? fileName : "Upload"}
                <UploadDocumentsIcon
                  style={{
                    width: 15,
                    height: 15,
                    stroke: "#344054",
                    padding: "8px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.palette.customColors.gray300}`,
                  }}
                />
                <VisuallyHiddenInput
                  accept=".xlsx,.csv"
                  type="file"
                  onChange={handleFileChange}
                />
              </Secondary>
            </Grid>
            <Grid item xs={12} display={"flex"} justifyContent={"end"}>
              <Typography
                variant="body2"
                color="blue"
                onClick={handleDownloadSampleFile}
                disabled={isDownloadingExcelMetricTemplateFile}
                sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
              >
                <Download style={{ width: 16, height: 16 }} /> Download Sample
                xlsx Template
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Primary
                type="submit"
                fullWidth
                disabled={isImporting}
                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
              >
                {isImporting ? "Importing..." : "Import"}
              </Primary>
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </Paper>
  );
};

export default ImportMetricsDataPopup;
